import React from 'react';
import { Slider } from 'antd';
import { GlobalVariable, SliderSettings } from '@kemu-io/kemu-core/common/managers/globalVariables.js';
import { DataType, SupportedTypes } from '@kemu-io/hs-types';
import styles from '../GlobalVariablesPanel.module.css';

type Props = {
  variable: GlobalVariable;
  onChange: (name: string,value: SupportedTypes, type: DataType) => void;
}

/**
 * Slider control component for global variables
 * @param variable - The global variable configuration
 * @param onChange - Callback when value changes
 */
const SliderControl = ({ variable, onChange }: Props) => {
  const settings = variable.controlSettings as SliderSettings;
  const currentValue = variable.lastValue as number ?? settings.min;

  const handleChange = (value: number) => {
    onChange(variable.name, value, DataType.Number);
  };

  return (
    <div className={styles.ControlSlider}>
      <Slider
        value={currentValue}
        className={styles.SliderElement}
        onChange={handleChange}
        min={settings.min}
        max={settings.max}
        step={settings.step}
        tooltip={{ formatter: (value) => value?.toString() }}
      />
      <span className={styles.ControlValue}>{currentValue}</span>
    </div>
  );
};

export default SliderControl;
